import Subscribed from "./Subscribed";

export default Subscribed